import type {CreateExpedientFormPayload} from "./create-expedient.schema";
import {CreateExpedientBody} from "@project/sdk/sales/zod";
import {createExpedient} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../expedient-keys";

export function createExpedientMutationOptions() {
  return mutationOptions({
    mutationKey: expedientMutationKeys.createExpedient,
    mutationFn: (payload: CreateExpedientFormPayload) =>
      createExpedient(CreateExpedientBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: expedientKeys.lists()});
    },
  });
}
